/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";

function Recommend() {
	return (
		<div className="content_inpage">
			<div className="pagesize">
				<ul className="bread">
					<li><a href="/">首頁</a></li>
					<li><a href="/container/recommend">好口碑分享</a></li>
				</ul>

				<h2 className="tit_main">好口碑分享</h2>
				<div className="content_box recommend_box">
					<div className="cb_set">
						<div className="rb_info flex_set">
							<div className="rb_box flex_box">
								<div className="rb_main flex_set">
									<div className="rb_img flex_box"><img src={require("../../img/640x300_06.jpg").default} alt="640x300_06" /></div>
									<div className="rb_txt flex_box">
										<h4>那對夫妻</h4>
										<p>我們實際試用後發現真的是生活中的小幫手，生活中很多瑣碎的事情，只需要透過語音聲控就可以搞定，甚至平常最容易忘記關的電器們，在家中把許多設備連線之後，輕輕鬆鬆就可以用語音聲控開關和設定情境 ！！</p>
									</div>
								</div>
								<div className="rb_link">
									<a href="https://www.facebook.com/1199693796723436/videos/1015716912231242" target="_blank" className="btn_facebook" rel="noreferrer"></a>
									<a href="https://www.youtube.com/watch?v=7Pyp89Aquio&t=1s" target="_blank" className="btn_youtube" rel="noreferrer"></a>
								</div>
							</div>
							<div className="rb_box flex_box">
								<div className="rb_main flex_set">
									<div className="rb_img flex_box"><img src={require("../../img/640x300_02.jpg").default} alt="640x300_02" /></div>
									<div className="rb_txt flex_box">
										<h4>馬克媽媽</h4>
										<p>我們家今年多了一位新成員，誤打誤撞變成馬克的褓母，為什麼呢？因為用聲控就能請「i寶貝」服務許多事情，這對馬克來說根本樂歪了！</p>
									</div>
								</div>
								<div className="rb_link">
									<a href="https://m.facebook.com/welovemark/posts/3712594835481441" target="_blank" className="btn_facebook" rel="noreferrer"></a>
									<a href="https://welovemark.pixnet.net/blog/post/229308503-%e9%a6%ac%e5%85%8b%e7%9a%84i%e5%af%b6%e8%b2%9d%e6%99%ba%e6%85%a7%e8%81%b2%e6%8e%a7%e8%a4%93%e6%af%8d" target="_blank" className="btn_pixnet" rel="noreferrer"></a>
								</div>
							</div>
							<div className="rb_box flex_box">
								<div className="rb_main flex_set">
									<div className="rb_img flex_box"><img src={require("../../img/640x300_04.jpg").default} alt="640x300_04" /></div>
									<div className="rb_txt flex_box">
										<h4>Lumina</h4>
										<p>其實來地球一陣子我還是有默默在學台語悠 有人也跟我一樣會聽歹億瓜嗎?Lumi~~~~~~ 看看之後有沒有機會唱台語歌給大家聽((害羞啦////////</p>
									</div>
								</div>
								<div className="rb_link">
									<a href="https://www.youtube.com/watch?v=tZGyI0gAHUg&feature=youtu.be" target="_blank" className="btn_youtube" rel="noreferrer"></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Recommend;